/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum ExamenstatusMetPrognose {
    GESLAAGD = "Geslaagd",
    GESLAAGD_PROGNOSE = "Geslaagd (prognose)",
    AFGEWEZEN = "Afgewezen",
    AFGEWEZEN_PROGNOSE = "Afgewezen (prognose)",
    VOORTIJDIG_TERUGGETROKKEN = "Voortijdig teruggetrokken",
    OVERIG = "Overig",
    TIJDENS_EXAMEN_TERUGGETROKKEN = "Tijdens examen teruggetrokken",
    VOORLAATSTE_JAAR = "Voorlaatste jaar",
    GESPREID_EXAMEN = "Gespreid examen",
    AANGEMELD = "Aangemeld"
}
